import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;
const locale = "sr";

export const locationsManagement = createApi({
    reducerPath: "locationsManagement",
    baseQuery: fetchBaseQuery({
        baseUrl: `${BASE_URL}`,
        prepareHeaders: (headers) => {
            const jwtToken = localStorage.getItem("userToken") || sessionStorage.getItem("userToken");

            if (jwtToken) {
                headers.set("authorization", `Bearer ${jwtToken}`);
            }

            return headers;
        },
    }),
    endpoints: (builder) => ({
        locationList: builder.mutation({
            query: (body) => {
                let url = `v1/${locale}/settings/locations`;

                for (const property in body) {
                    if ((property && body[property]) || (property === "startPage" && body[property] === 0)) {
                        if (url?.includes("?")) {
                            url += `&${property}=${body[property]}`;
                        } else {
                            url += `?${property}=${body[property]}`;
                        }
                    }
                }

                return {
                    url: url,
                    method: "GET",
                };
            },
        }),
        viewLocation: builder.mutation({
            query: (locationId) => ({
                url: `v1/${locale}/settings/locations/${locationId}`,
                method: "GET",
            }),
        }),
        addLocation: builder.mutation({
            query: (body) => ({
                url: `v1/${locale}/settings/locations`,
                method: "POST",
                body: body,
            }),
        }),
        updateLocation: builder.mutation({
            query: ({ body, locationId }) => ({
                url: `v1/${locale}/settings/locations/${locationId}`,
                method: "PATCH",
                body: body,
            }),
        }),
        deleteLocation: builder.mutation({
            query: (locationId) => ({
                url: `v1/${locale}/settings/locations/${locationId}`,
                method: "DELETE",
            }),
        }),
    }),
});

export const { useLocationListMutation, useViewLocationMutation, useAddLocationMutation, useUpdateLocationMutation, useDeleteLocationMutation } =
    locationsManagement;
